const carousel = document.querySelector('.js-carousel');
const carouselNav = Array.from(carousel.querySelectorAll('.carousel-navigation .bullet'));
const carouselSlides = Array.from(carousel.querySelectorAll('.slide'));
const intervalTimeMs = 5000;

export const Slider = () => {
    if (!carousel) {
        return;
    }

    let index = 0;

    const changeSlide = (currentIndex) => {
        carouselSlides.forEach(slide => slide.classList.remove('active'));
        carouselSlides[currentIndex].classList.add('active');
    }
    const changeBullet = (currentIndex) => {
        carouselNav.forEach(bullet => bullet.classList.remove('active'));
        carouselNav[currentIndex].classList.add('active');
    }

    carousel.addEventListener('click', event => {
        const target = event.target;
        if (!target.classList.contains('bullet')) {
            return;
        }

        index = carouselNav.indexOf(target);

        changeSlide(index);
        changeBullet(index);
    });

    setInterval(() => {
        index = index + 1 >= carouselSlides.length ? 0 : index + 1;
        changeSlide(index);
        changeBullet(index);
    }, intervalTimeMs);
}